import { updateIssueTeaser, updateIssueFilter, updateIssueStatus, updateYearFilter, updateSelectedYearFilter, updateNewsletterIssueFilter, updateNewsletterIssueTeaser } from "./ArtikelVerbleibendUpdate.js";
import { getIntersectingElements } from "./helper.js";

import contentTracker from "./InhaltGelesen.js";

document.addEventListener('DOMContentLoaded', () => heftDetailAusgabenCount());
document.addEventListener('htmx:afterSettle', () => heftDetailAusgabenCount());

document.addEventListener('DOMContentLoaded', () => heftUebersichtTeaserCount());
document.addEventListener('htmx:afterSettle', () => heftUebersichtTeaserCount());

document.addEventListener('DOMContentLoaded', () => updateUebersichtAusgabenFilterDots('heftuebersicht_ausgabe_ungelesene_'));
document.addEventListener('htmx:afterSettle', () => updateUebersichtAusgabenFilterDots('heftuebersicht_ausgabe_ungelesene_'));

document.addEventListener('DOMContentLoaded', () => updateUebersichtAusgabenFilterDots('newsletter_ausgabe_ungelesene_'));
document.addEventListener('htmx:afterSettle', () => updateUebersichtAusgabenFilterDots('newsletter_ausgabe_ungelesene_'));

document.addEventListener('htmx:afterSettle', () => newsletterDetailAusgabenCount());
document.addEventListener('DOMContentLoaded', () => newsletterDetailAusgabenCount());

document.addEventListener('htmx:afterSettle', () => updateNewsletterUebersichtJahrFilter());
document.addEventListener('DOMContentLoaded', () => updateNewsletterUebersichtJahrFilter());

document.addEventListener('htmx:afterSettle', () => updateNewsletterUebersichtTeaserCount());
document.addEventListener('DOMContentLoaded', () => updateNewsletterUebersichtTeaserCount());


// Page navigation vor/zurück knopf Artikel markieren
window.addEventListener('pageshow', (event) => {
    if (event.eventPhase == 2 && String(window.performance.getEntriesByType("navigation")[0].type) == "back_forward") {
        heftDetailAusgabenCount();
        heftUebersichtTeaserCount();
        updateHeftUebersichtJahrFilter();
        updateUebersichtAusgabenFilterDots('heftuebersicht_ausgabe_ungelesene_');
        newsletterDetailAusgabenCount();
        updateNewsletterUebersichtJahrFilter();
        updateNewsletterUebersichtTeaserCount();
        updateUebersichtAusgabenFilterDots('newsletter_ausgabe_ungelesene_');
    }
});


//
// Hier werden die noch zu lesenden Artikel berechnet und angezeigt
// Alle Funktionnen die das updaten und anzeigen von noch zu lesenden Artikeln betreffen sind hier zu finden
// z.B. Heft Detail Ausgaben übersicht (linke seite) noch zu lesende Artikel
//

/**
 * @description Einstiegspunkt zum aktuallisieren von noch ungelesenen Artikeln in Heft Detail ansicht, Onload und update
 * @param articles_read
 */
export function heftDetailAusgabenCount(articles_read = null) {
    const ausgaben = document.querySelectorAll("li[id^=filter_ausgabe_");
    const ausgabeStatus = document.querySelectorAll("span[id^=heftausgabe_status_");

    if (ausgaben.length < 1 && ausgabeStatus.length < 1) { return; }

    if (articles_read !== null) {
        updateHeftDetailAusgabenCount(ausgaben, articles_read);
        updateHeftDetailStatus(ausgabeStatus, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateHeftDetailAusgabenCount(ausgaben, articles_read);
            updateHeftDetailStatus(ausgabeStatus, articles_read);
        });
    }
}

/**
 * @description Berechne ungelesene Artikel in Ausgabe für Filter und Aktuallisere Zahl
 * @param ausgaben
 * @param articles_read
 */
function updateHeftDetailAusgabenCount(ausgaben, articles_read) {
    ausgaben.forEach(ausgabe => {
        let heft_artikel_ids = JSON.parse(ausgabe.dataset.articleids);
        const parts = ausgabe.id.split('_');
        const heft_id = parts[parts.length - 1];

        let artikel_count_max = ausgabe.dataset.articles ? ausgabe.dataset.articles : ausgabe.dataset.articlecount;

        if (heft_artikel_ids == null || heft_artikel_ids.length < 1) {
            return;
        }

        let heft_artikel_read_count = getIntersectingElements(articles_read, heft_artikel_ids).length;
        updateIssueFilter(heft_id, artikel_count_max - heft_artikel_read_count);
    });
}

function updateHeftDetailStatus(ausgabeStatus, articles_read) {
    ausgabeStatus.forEach(status => {
        const artikelIds = JSON.parse(status.dataset.articleids);
        const artikelAnzahl = Number(status.dataset.articlecount);
        const geleseneArtikelAnzahl = getIntersectingElements(articles_read, artikelIds).length;

        updateIssueStatus(status, geleseneArtikelAnzahl, artikelAnzahl);
    });
}

/**
 * @description Einstiegspunkt zum aktuallisieren von noch ungelesenen Artikeln in Heft übersichts Seite, Onload und update
 * @param articles_read
 */
export function heftUebersichtTeaserCount(articles_read = null) {
    const teaser = document.querySelectorAll("div[id^=heftausgabe_teaser_");

    if (teaser.length < 1) { return; }

    if (articles_read !== null) {
        updateHeftUebersichtTeaserCount(teaser, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateHeftUebersichtTeaserCount(teaser, articles_read);
        });
    }
}

/**
 * @description Berechne ungelesene Artikel in Ausgabe für Teaser und Aktuallisere Zahl
 * @param teaser
 * @param articles_read
 */
function updateHeftUebersichtTeaserCount(teaser, articles_read) {
    teaser.forEach(singleTeaser => {
        let heft_artikel_ids = JSON.parse(singleTeaser.dataset.articleids);
        const parts = singleTeaser.id.split('_');
        const heft_id = parts[parts.length - 1];

        let artikel_count_max = singleTeaser.dataset.articlecount;

        if (heft_artikel_ids == null || heft_artikel_ids.lenght < 1) {
            return;
        }

        let heft_artikel_read_count = getIntersectingElements(articles_read, heft_artikel_ids).length;
        updateIssueTeaser(heft_id, artikel_count_max - heft_artikel_read_count);
    });
}

/**
 * @description Berechne ungelesene Artikel je Ausgabe und zeige/verstecke den Dot am Monatsfilter.
 *              Wird sowohl für die Heft- als auch für die Newsletter-Übersicht verwendet.
 * @param {string} idPrefix - ID-Präfix der Dot-Spans, z.B. "heftuebersicht_ausgabe_ungelesene_"
 *                            oder "newsletter_ausgabe_ungelesene_"
 */
function updateUebersichtAusgabenFilterDots(idPrefix) {
    const ausgabenDots = document.querySelectorAll(`span[id^=${idPrefix}`);

    if (ausgabenDots.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }

        ausgabenDots.forEach(ausgabeDot => {
            if (!ausgabeDot.dataset.articleids) {
                return;
            }

            const ausgabeArtikelIds = JSON.parse(ausgabeDot.dataset.articleids);
            if (!Array.isArray(ausgabeArtikelIds) || ausgabeArtikelIds.length < 1) {
                updateYearFilter(ausgabeDot, 0);
                return;
            }

            const geleseneArtikelAnzahl = getIntersectingElements(articles_read, ausgabeArtikelIds).length;
            const ungeleseneArtikelAnzahl = ausgabeArtikelIds.length - geleseneArtikelAnzahl;
            updateYearFilter(ausgabeDot, ungeleseneArtikelAnzahl);
        });
    });
}

/**
 * @param articles_read
 */
export function newsletterDetailAusgabenCount(articles_read = null) {
    const ausgaben = document.querySelectorAll("li[id^=newsletterausgabe-filter-ausgabe-");

    if (ausgaben.length < 1) { return; }

    if (articles_read !== null) {
        updateNewsletterDetailAusgabenCount(ausgaben, articles_read);
    } else {
        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            if (articles_read == null) { return; }

            updateNewsletterDetailAusgabenCount(ausgaben, articles_read);
        });
    }
}

/**
 * @param ausgaben
 * @param articles_read
 */
function updateNewsletterDetailAusgabenCount(ausgaben, articles_read) {
    ausgaben.forEach(ausgabe => {

        if (ausgabe.dataset.articleids == undefined || ausgabe.dataset.articleids == null) {
            return;
        }

        let ausgabe_artikel_ids = JSON.parse(ausgabe.dataset.articleids);
        const parts = ausgabe.id.split('-');
        const ausgabe_id = parts[parts.length - 1];

        let artikel_count_max = ausgabe.dataset.articles ? ausgabe.dataset.articles : ausgabe.dataset.articlecount;

        if (ausgabe_artikel_ids == null || ausgabe_artikel_ids.lenght < 1) {
            return;
        }

        let newsletter_artikel_read_count = getIntersectingElements(articles_read, ausgabe_artikel_ids).length;
        updateNewsletterIssueFilter(ausgabe_id, artikel_count_max - newsletter_artikel_read_count);
    });
}

/**
 */
function updateNewsletterUebersichtJahrFilter() {
    let jahrUngelesene = document.querySelectorAll("span[id^=jahr-ungelesene-");

    if (jahrUngelesene.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }
        jahrUngelesene.forEach(jahr => {
            let newsletter = JSON.parse(jahr.dataset.articleids);
            let newsletterKeys = Object.keys(newsletter);
            let anzahlnewsletter = newsletterKeys.length;
            newsletterKeys.forEach(newsletterID => {
                let artikelAnzahl = newsletter[newsletterID].length;
                let geleseneArtikelAnzahl = getIntersectingElements(articles_read, newsletter[newsletterID]).length;
                if (artikelAnzahl > 0 && artikelAnzahl - geleseneArtikelAnzahl == 0) {
                    anzahlnewsletter = anzahlnewsletter - 1;
                }
            });

            if (jahr.id.includes("ausgewaehlt")) {
                updateSelectedYearFilter(jahr, anzahlnewsletter);
            } else {
                updateYearFilter(jahr, anzahlnewsletter);
            }
        });
    });
}

function updateNewsletterUebersichtTeaserCount() {
    const teaser = document.querySelectorAll("div[id^=newsletterausgabe_teaser");

    if (teaser.length < 1) { return; }

    contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
        if (articles_read == null) { return; }

        teaser.forEach(singleTeaser => {
            let newsletter_artikel_ids = JSON.parse(singleTeaser.dataset.newsletterArticles);
            const parts = singleTeaser.id.split('_');
            const newsletter_id = parts[parts.length - 1];

            let artikel_count_max = newsletter_artikel_ids.length;

            if (newsletter_artikel_ids.length < 1 || artikel_count_max < 1) {
                return;
            }

            let newsletter_artikel_read_count = getIntersectingElements(articles_read, newsletter_artikel_ids).length;
            updateNewsletterIssueTeaser(newsletter_id, artikel_count_max - newsletter_artikel_read_count);
        });
    });

}
